<template>
  <div class="qris-info">
    <div class="BatasPembayaran p-t-16">
      <p
        class="f-Overpass f-14 f-c-midgrey remove-margin"
        style="font-weight: 700"
      >
        Jika saat ini anda membuka halaman BOS menggunakan PC/Laptop,
      </p>
    </div>
    <div class="f-c-midgrey f-12 remove-margin" style="margin-top: 5px">
      <ol class="p-x-20 remove-margin">
        <li>
          Buka aplikasi pembayaran OVO, GOPAY, DANA, LINKAJA, BCA QR atau
          eWallet lainnya
        </li>
        <li>Scan QR Code dibawah ini:</li>
      </ol>
    </div>
    <div class="p-t-15">
      <img
        :src="
          'https://central-kube.smartlink.id/qr/direct/' +
          detailBayar[0].qris.qrcode
        "
        alt="qr"
        id="img_qr"
      />
    </div>
    <div class="BatasPembayaran p-t-16">
      <p
        class="f-Overpass f-14 f-c-midgrey remove-margin"
        style="font-weight: 700"
      >
        Jika saat ini anda membuka halaman BOS menggunakan HP
      </p>
      <p class="f-Overpass f-14 f-c-midgrey remove-margin">
        Cara melakukan pembayarannya adalah sebagai berikut:
      </p>
    </div>
    <div
      class="f-c-midgrey remove-margin"
      style="margin-top: 5px; font-size: 11px"
    >
      <ol class="p-x-20 remove-margin">
        <li>
          Simpan gambar qrcode diatas, dengan klik
          <a
            :href="
              'https://central-kube.smartlink.id/qr/download/' +
              detailBayar[0].qris.qrcode
            "
            style="text-decoration: none"
            >DOWNLOAD DI SINI</a
          >
        </li>
        <li>
          Buka aplikasi pembayaran OVO, GOPAY, DANA, LINKAJA, BCA QR atau
          eWallet lainnya
        </li>
        <li>Pilih Scan</li>
        <li>Tekan tombol gallery</li>
        <li>Pilih gambar QR berikut untuk pembayaran anda</li>
        <li>
          Pastikan penerima atas nama SMARTLINK atau PT. Ada Ide Langsung Jalan
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "Qris",
  data() {
    return {
      isLoading: false,
      idTraining: this.$route.params.idTraining,
    };
  },
  computed: {
    ...mapGetters(moduleName, {
      detailBayar: "detailBayar",
    }),
  },

  methods: {},
};
</script>

<style scoped>
#img_qr {
  width: 100%;
  height: 100%;
}
@media (min-width: 500px) {
  #img_qr {
    width: 50%;
    height: 50%;
    display: flex;
    margin: auto;
  }
}
</style>
